import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import {
    fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationFailedAction,
    fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationSuccessAction,
    fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeFailedAction,
    fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeSuccessAction,
} from '../actions/questionGroupStep';
type State = {
    questionGroupStep: {
        byId: { [id: string]: string } | any;
        allIds: Array<string | any>;
    };
    loading: boolean;
    errorMessage: null | any;
};
const INITIAL_STATE: State = {
    questionGroupStep: {
        byId: {},
        allIds: [],
    },
    loading: false,
    errorMessage: null,
};

const fetchQuestionGroupStep = (state: State): State => {
    return state;
};

const fetchQuestionGroupStepSuccess = (state: State): State => {
    return state;
};

const fetchQuestionGroupStepFailed = (state: State): State => {
    return state;
};

const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimType = (
    state: State,
): State => {
    return {
        ...state,
        loading: true,
    };
};

const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeSuccess = (
    state: State,
    action: PayloadAction<fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeSuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'code',
        action.payload.body.data,
    );

    return {
        ...state,
        loading: false,
        questionGroupStep: {
            ...state.questionGroupStep,
            byId: byId,
            allIds: allIds,
        },
    };
};
const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeFailed = (
    state: State,
    action: PayloadAction<fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeFailedAction>,
) => {
    return {
        ...state,
        errorMessage: action.payload.body,
        loading: false,
    };
};

const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplication =
    (state: State): State => {
        return {
            ...state,
            loading: true,
        };
    };

const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationSuccess =
    (
        state: State,
        action: PayloadAction<fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationSuccessAction>,
    ): State => {
        const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
            'code',
            action.payload.body.data,
        );

        return {
            ...state,
            loading: false,
            questionGroupStep: {
                ...state.questionGroupStep,
                byId: byId,
                allIds: allIds,
            },
        };
    };
const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationFailed =
    (
        state: State,
        action: PayloadAction<fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationFailedAction>,
    ): State => {
        return {
            ...state,
            errorMessage: action.payload.body,
            loading: false,
        };
    };

const clearGroupStepState = (): State => {
    return INITIAL_STATE;
};

const questionGroupStep = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_QUESTION_GROUP_STEP]: fetchQuestionGroupStep,
    [ActionTypes.FETCH_QUESTION_GROUP_STEP_SUCCESS]:
        fetchQuestionGroupStepSuccess,
    [ActionTypes.FETCH_QUESTION_GROUP_STEP_FAILED]:
        fetchQuestionGroupStepFailed,
    [ActionTypes.CLEAR_QUESTION_GROUP_STEP]: clearGroupStepState,
    [ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE]:
        fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimType,
    [ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_SUCCESS]:
        fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeSuccess,
    [ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_FAILED]:
        fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeFailed,
    [ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION]:
        fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplication,
    [ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION_SUCCESS]:
        fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationSuccess,
    [ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION_FAILED]:
        fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationFailed,
});

export default questionGroupStep;
